import React from "react";
import { Checkbox, Form, Input } from "../../../../_core/_components";
import { EditCanalProperty } from "./reducer";

type Props = {
  form: any;
  dispatch: React.Dispatch<{
    type: EditCanalProperty;
    payload: any;
  }>;
};

const ModalContent: React.FC<Props> = ({ form, dispatch }: Props) => {
  return (
    <Form
      items={[
        <Input
          state={[
            form.nomeCanal,
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_NOME", payload: value }),
          ]}
          label="Nome"
        />,
        <Checkbox
          label="Ativo"
          checked={form.flagAtivo}
          onClick={() =>
            dispatch({ type: "SET_ATIVO", payload: !form.flagAtivo })
          }
        />,
      ]}
    />
  );
};

export default ModalContent;
